import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const SettingsTeachingBubbleForRoleBasedFRE = () =>
  import(
    /* webpackChunkName: "4-feat-settings-teaching-bubble-role-based-fre" */ './SettingsTeachingBubbleForRoleBasedFRE'
  );

export default lazyLoadOnRender({ loader: SettingsTeachingBubbleForRoleBasedFRE });
